<!DOCTYPE html>
<html lang="tr">
<head>
<meta charset="utf-8">
<meta name="viewport" content="width=device-width, initial-scale=1">

<title>{{ post.seo.docTitle }}</title>
<meta name="description" content="{{ post.seo.description }}">
<meta name="robots" content="index, follow, max-image-preview:large">
<link rel="canonical" href="{{ post.canonical }}">

<meta property="og:type" content="article">
<meta property="og:site_name" content="Frawgraphy">
<meta property="og:locale" content="tr_TR">
<meta property="og:url" content="{{ post.canonical }}">
<meta property="og:title" content="{{ post.seo.ogTitle }}">
<meta property="og:description" content="{{ post.seo.ogDescription }}">
<meta property="og:image" content="{{ post.seo.ogImage }}">
<meta property="article:published_time" content="{{ post.date }}">
<meta name="twitter:card" content="summary_large_image">

<link rel="icon" href="/favicon.ico" sizes="any">
<link rel="icon" type="image/png" sizes="32x32" href="/assets/img/favicon-32.png">
<link rel="icon" type="image/png" sizes="16x16" href="/assets/img/favicon-16.png">
<link rel="apple-touch-icon" sizes="180x180" href="/assets/img/apple-touch-icon.png">
<link rel="manifest" href="/site.webmanifest">

<meta name="theme-color" content="#060606" media="(prefers-color-scheme: dark)">
<meta name="theme-color" content="#f5f3f0" media="(prefers-color-scheme: light)">

<link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Bodoni+Moda:ital,opsz,wght@0,6..96,400;0,6..96,500;0,6..96,700;0,6..96,900;1,6..96,400;1,6..96,700&family=Inter:wght@300;400;500;600&family=JetBrains+Mono:wght@400;500&display=swap">
<link rel="stylesheet" href="../assets/css/style.css?v=20260920b">
<noscript><style>.reveal{opacity:1;transform:none}</style></noscript>

<script>
  (function () {
    try {
      var t = localStorage.getItem('frawgraphy-theme');
      if (!t) t = matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
      document.documentElement.setAttribute('data-theme', t);
      document.documentElement.setAttribute('data-lang', localStorage.getItem('frawgraphy-lang') || 'tr');
    } catch (e) {
      document.documentElement.setAttribute('data-theme', 'dark');
      document.documentElement.setAttribute('data-lang', 'tr');
    }
  })();
</script>

<script type="application/ld+json">
{
  "@context": "https://schema.org",
  "@type": "BlogPosting",
  "headline": {{{ post.jsonld.headline }}},
  "description": {{{ post.jsonld.description }}},
  "inLanguage": "tr-TR",
  "datePublished": "{{ post.date }}",
  "dateModified": "{{ post.date }}",
  "wordCount": {{ post.wordCount }},
  "keywords": {{{ post.jsonld.keywords }}},
  "mainEntityOfPage": { "@type": "WebPage", "@id": "{{ post.canonical }}" },
  "author": { "@type": "Organization", "name": "Frawgraphy Studio", "url": "https://frawgraphy.com/" },
  "publisher": { "@type": "Organization", "name": "Frawgraphy Studio", "url": "https://frawgraphy.com/" }
}
</script>
<script type="application/ld+json">
{
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    { "@type": "ListItem", "position": 1, "name": "Ana sayfa", "item": "https://frawgraphy.com/" },
    { "@type": "ListItem", "position": 2, "name": "Günlük", "item": "https://frawgraphy.com/blog.html" },
    { "@type": "ListItem", "position": 3, "name": {{{ post.jsonld.shortTitle }}} }
  ]
}
</script>
</head>
<body>

<a class="skip-link" href="#main" data-i18n="skip">İçeriğe geç</a>

{{> header }}

{{> menu }}

<main id="main" class="page">
  <div class="shell">
    <nav class="crumbs" aria-label="Site yolu">
      <ol>
        <li><a href="../index.html" data-i18n="blog.crumbHome">Ana sayfa</a></li>
        <li><a href="../blog.html" data-i18n="blog.crumbBlog">Günlük</a></li>
        <li aria-current="page">{{ post.shortTitle }}</li>

      </ol>
    </nav>

    <article class="article" lang="tr">
      <header class="article-head">
        <p class="post-meta">
          <span class="card-cat">{{ post.category }}</span>
          <time datetime="{{ post.date }}">{{ post.dateText }}</time>
          <span class="post-read">{{ post.readMinutes }} dk</span>
        </p>
        <h1 class="page-title">{{{ post.titleHtml }}}</h1>
        <p class="article-lede">
          {{ post.lede }}
        </p>
        <p class="lang-note">
          <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 7.6v.9"/></svg>
          <span data-i18n="blog.notice">Yazılar Türkçe yayımlanmaktadır.</span>
        </p>
      </header>

      <figure class="article-figure">
        <img src="{{ post.cover.url }}" alt="{{ post.cover.alt }}" width="{{ post.cover.w }}" height="{{ post.cover.h }}" loading="lazy" decoding="async">
        <figcaption>{{ post.cover.caption }}</figcaption>
      </figure>

{{{ post.bodyHtml }}}
    </article>

    <nav class="article-nav" aria-label="Diğer yazılar">
      <a href="{{ prev.href }}">← {{ prev.label }}</a>
      <a href="{{ next.href }}">{{ next.label }} →</a>
    </nav>

    <aside class="page-cta">
      <h2 data-i18n="blog.cta.title">Bir proje mi var?</h2>
      <p data-i18n="blog.cta.text">Takvimimiz iki ay önceden dolar. Tarih ve kapsamı yazmanız yeterli.</p>
      <a class="btn btn--primary" href="../index.html#contact">
        <span data-i18n="blog.cta.btn">Çekim planla</span>
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>
      </a>
    </aside>
  </div>
</main>

{{> footer }}

<script src="../assets/js/i18n.js?v=20260920b" defer></script>
<script src="../assets/js/main.js?v=20260920b" defer></script>
</body>
</html>
